<template>
    <div :class="{category_wrapper: true}">
        <div :class="{click: loader || loading}">
            <va-modal @keydown.native.esc="escaped" style="overflow-y: auto;" :title="_(title)" width="900px"
                ref="new_category_modal" :backdrop-clickable="false" @hide="hideModal" @confirm="confirmCategory">
                <div slot="header" :class="{click: loader || loading}">
                    <div style="display: flex; justify-content: space-between; align-items: center">
                        <span style="font-weight: bold; font-size: 18px;">{{ title }}</span>
                        <va-button @click.native="hideModal">
                            <va-icon type="times"></va-icon>
                        </va-button>
                    </div>
                </div>
                <div slot="body" :class="{click: loader || loading}">
                    <va-form ref='category_form'>
                        <div class="form_labels_modal">

                            <va-input v-model="label_english" @keyup.native.enter="confirmCategory" showClean
                                :placeholder="'English title'" :rules="[{type:'required'}]"></va-input>
                            <va-input v-model="label_pashto" @keyup.native.enter="confirmCategory" showClean
                                :placeholder="'پښتو عنوان'"></va-input>
                            <va-input v-model="label_dari" @keyup.native.enter="confirmCategory" showClean
                                :placeholder="'عنوان دری'"></va-input>

                        </div>
                    </va-form>
                </div>

                <div slot="footer" :class="{click: loader || loading}" style="clear: both;">
                    <div class="modal_footer">
                        <!-- v-if="can_delete" -->
                        <va-button :loading="loading" @click.native="deleteObject" type="info">
                            {{ _('Delete') }}</va-button>
                        <div style="width: 100%">
                            <div style="display: flex; justify-content: flex-end;">
                                <div class="error_category field_label" v-if="error_message != ''">
                                    {{ error_message }}
                                </div>
                                <va-button :loading="loader" type="primary" @click.native="confirmCategory"
                                    style="margin-left: 0">
                                    {{ _('Confirm') }}</va-button>

                                <va-button @click.native="hideModal" style="margin-left: 10px">{{ _('Cancel') }}
                                </va-button>
                            </div>

                        </div>

                    </div>
                </div>
            </va-modal>
        </div>
    </div>
</template>

<script>
    import Parse from "@/main.js"
    import { mapGetters, mapActions } from "vuex";

    export default {
        props: ['title', 'department', 'category_for_update', 'can_delete'],

        data() {
            return {
                label_english: '',
                label_pashto: '',
                label_dari: '',
                loader: false,
                error_message: '',
            }
        },

        computed: {
            ...mapGetters(['user', 'getUserRolesFromState', 'getAllDepartments', 'loading']),
        },

        methods: {
            ...mapActions(['fetchDepartments', 'fetchDepartmentCategories', 'fetchGlobalCategories', 'fetchCategoriesForThisCompany']),

            escaped(e) {
                e.stopPropagation();
            },

            async confirmCategory() {
                this.$refs.category_form.validateFields(async result => {
                    if (result.isvalid) {
                        this.loader = true
                        this.$emit('disable-screen', true)

                        var response;
                        if (!this.category_for_update) {
                            // check if the category already exists, new category is creating
                            var conditions = [];
                            conditions.push(new Parse.Query("Category").equalTo("slug", this.label_english.toString().trim().slugify()))
                            conditions.push(new Parse.Query("Category").equalTo("department", this.department))
                            var mainQuery = Parse.Query.and(...conditions)
                            response = await mainQuery.first()
                        }

                        if (!response) {
                            // check if the logged i user is in the members list of not, if not, then insert it

                            var promise_object;
                            // update category
                            if (this.category_for_update) {
                                this.category_for_update.set('label_english', this.label_english)
                                this.category_for_update.set('label_pashto', this.label_pashto)
                                this.category_for_update.set('label_dari', this.label_dari)
                                promise_object = this.category_for_update.save()
                            } else {
                                // create category
                                const Category = Parse.Object.extend("Category");
                                const newCategory = new Category();

                                promise_object = newCategory.save({
                                    label_english: this.label_english,
                                    label_pashto: this.label_pashto,
                                    label_dari: this.label_dari,
                                    slug: this.label_english.slugify(),
                                    type: this.$route.matched[0].name.substring(0, this.$route.matched[0].name.length - 1),
                                    department: this.department,
                                    createdBy: this.user
                                })
                            }

                            promise_object.then(async created_or_updated_category => {
                                // create activities
                                var action = this.category_for_update ? 'updateCategory' : 'createCategory'

                                var previous_labeles = {};
                                if (this.category_for_update) {
                                    previous_labeles['english'] = this.category_for_update.get('label_english')
                                    previous_labeles['pashto'] = this.category_for_update.get('label_pashto')
                                    previous_labeles['dari'] = this.category_for_update.get('label_dari')
                                }
                                await this.createdActivities(created_or_updated_category, action, previous_labeles)


                                if (this.department) {
                                    // department based
                                    if (this.user.get('roles').includes('admin')) {
                                        await this.fetchDepartments()
                                    }
                                    else {
                                        await this.fetchDepartmentCategories()
                                    }
                                } else {
                                    // global
                                    await this.fetchGlobalCategories()
                                }

                                this.loader = false
                                this.$emit('disable-screen', false)
                                this.error_message = ''
                                this.hideModal()
                                this.$notify({
                                    group: 'foo',
                                    text: this._(this.category_for_update ? 'Category was updated' : 'Category was created'),
                                    duration: 4000,
                                    position: 'top left',
                                    type: 'success'
                                });
                                // setTimeout(() => {
                                //     this.$router.replace('/' + this.$route.matched[0].name + '/' + this.$route.params.scope + '/' + created_or_updated_category.get('slug'))
                                // }, 1000)
                            }).catch(error => {
                                this.loader = false
                                this.$emit('disable-screen', false)
                                this.error_message = this.category_for_update ? 'Error accured while updating category' : 'Error accured while creating category'
                                this.$notify({
                                    group: 'foo',
                                    title: this._('System Error'),
                                    text: this._(this.error_message),
                                    duration: 4000,
                                    position: 'top left',
                                    type: 'error'
                                });
                            })
                        } else {
                            this.loader = false
                            this.$emit('disable-screen', false)
                            this.error_message = 'This category already exists'
                            this.$notify({
                                group: 'foo',
                                title: this._('Duplicate'),
                                text: this._(this.error_message),
                                duration: 4000,
                                position: 'top left',
                                type: 'error'
                            });
                        }
                    } else {
                        this.$emit('disable-screen', false)
                        this.error_message = ''
                    }
                })
            },

            async createdActivities(category, action, previous_labels) {
                var department_slug = this.department ? this.department.get('slug') : 'global';

                await this.g_newActivity({
                    label_english: category.get('label_english'),
                    label_pashto: category.get('label_pashto'),
                    label_dari: category.get('label_dari'),
                    previous_label_english: previous_labels['english'] || '',
                    previous_label_pashto: previous_labels['pashto'] || '',
                    previous_label_dari: previous_labels['dari'] || '',
                    type: this.$route.matched[0].name.substring(0, this.$route.matched[0].name.length - 1),
                    action: action,
                    url: '/' + this.$route.matched[0].name + '/' + department_slug + '/' + category.get('slug'),
                    to: null,
                    category: category,
                    department: this.department,
                    class: 'Category',
                    reference_id: category.id
                })
            },

            async deleteObject() {
                await this.g_deleteObject(this.category_for_update)
                    .then(async result => {
                        if (result) {
                            if (this.department) {
                                // department based
                                if (this.user.get('roles').includes('admin')) {
                                    await this.fetchDepartments()
                                }
                                else {
                                    await this.fetchDepartmentCategories()
                                }

                            } else {
                                // global
                                await this.fetchGlobalCategories()
                            }
                            // this.$emit('reload')
                        }
                        this.hideModal()
                        this.$router.replace('/' + this.$route.matched[0].name);
                    }).catch(e => {
                    })
            },

            hideModal() {
                if (!this.loader) {
                    this.$emit('hide-modal', true)
                    this.$emit('disable-screen', false)
                    this.error_message = ''
                    this.label_english = ''
                    this.label_pashto = ''
                    this.label_dari = ''
                    this.$refs.new_category_modal.close()
                }
            },

            settings() {
                if (this.category_for_update) {
                    this.label_english = this.category_for_update.get('label_english')
                    this.label_pashto = this.category_for_update.get('label_pashto')
                    this.label_dari = this.category_for_update.get('label_dari')
                    this.is_global = this.category_for_update.get('is_global')
                    if (this.category_for_update.get('members')) {
                        var temp = []
                        temp = this.category_for_update.get('members').map(user => {
                            return { user: user, isPrev: true }
                        })
                    }
                }
            }
        },

        watch: {
            '$route'(to, from) {
                this.settings()
            },

            category_for_update(val) {
                this.settings()
            }
        },

        mounted() {
            this.settings()
            if (this.$refs && this.$refs.new_category_modal) {
                this.$refs.new_category_modal.open()
            }
        }
    }

</script>

<style scoped>
    .category_wrapper {
        position: relative;
    }

    .modal_footer {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        align-items: center
    }

    .click {
        pointer-events: none
    }

    .error_category {
        color: red !important;
        margin-right: 10px
    }

    .form_labels_modal {
        display: flex !important;
        justify-content: space-between !important;
    }

    .form_labels_modal .va-has-error {
        display: flex !important;
        flex-direction: column;
    }



    .form_labels_modal .va-input-con {
        margin-right: 5px;
        display: flex !important;
        justify-content: space-between !important;
    }
</style>